import PlainInput, { PlainInputProps, Ref } from './plain-input'
import PlainInputNumber from './plain-input-number'

export { PlainInputStateful } from './plain-input-stateful'
export { PlainInputNumberStateful } from './plain-input-number-stateful'
export { PlainInputCurrency } from './plain-input-currency'

export default PlainInput

export type { PlainInputProps, Ref }

export { PlainInputNumber }
